import React from 'react';

import './Button.icon.scss';

function ButtonIcon({ children, type, className, size, handleClick, disabled }) {

    const _size = size ? size : 50;
    if (handleClick) {
        return (
            <button onClick={handleClick} className={`button icon ${className || ''}`} type={type || 'button'} style={{ width: `${_size}px`, height: `${_size}px` }} disabled={disabled}>
                {children}
            </button>
        )
    }
    return (
        <button className={`button icon ${className || ''}`} type={type || 'button'} style={{ width: `${_size}px`, height: `${_size}px` }} disabled={disabled}>
            {children}
        </button>
    )
}

export default ButtonIcon;